
define("json!gigaset_csp/handles/gigaset_csp.json", function(){ return {
	"gigaset_csp_service_product_register": [
		"./components/product/register"
	],

	"gigaset_csp_service_repair_register_plugin_product": [
		"./components/order/repair/form"
	],

	"gigaset_csp_service_repair_register_plugin_description": [
		"./components/order/repair/form/description"
	],

	"gigaset_csp_service_repair_register_plugin_address": [
		"./components/order/repair/form/address"
	],

	"gigaset_csp_service_repair_register_plugin_reference": [
		"./components/order/repair/form/reference"
	],

	"gigaset_csp_customer_request_index": [
		"./components/customer/request"
	],

	"gigaset_csp_handsetbase_registration" : [
		"./components/handsetbase/registration"
	],

	"gigaset_csp_compatibility_byproducts": [
		"./components/compatibility/byproducts"
	],

	"gigaset_csp_compatibility_byfeatures": [
		"./components/compatibility/byfeatures"
	],

	"gigaset_csp_support_detail": [
		"./components/support/detail/intro"
	],

	"gigaset_csp_support_detail_faq": [
		"./components/support/detail/faq",
		"./components/support/detail/faq/categories"
	],

	"gigaset_csp_search_field": [
		"./components/support/detail/faq",
		"./components/search/autocomplete"
	],

	"catalog_product_view": [
		"./components/product/support",
		"./components/product/downloads"
	],

	"gigaset_csp_support_search_results": [
		"./components/support/detail/faq"
	],

	"gigaset_csp_support_search_results_single": [
		"./components/support/detail/faq"
	],

	"catalogsearch_result_index": [
		"./components/support/detail/faq"
	],

	"gigaset_csp_support_downloads": [
		"./components/downloads/list"
	]
};});

